<mat-card>
  <page-title [title]="title"></page-title>
  <div class="row">
    <div class="col-xs-3">
      <button mat-button (click)="loadPreviousDay()" *ngIf="showPrevious()">
        <mat-icon>navigate_before</mat-icon>
      </button>
    </div>
    <div class="col-xs-6 date">{{ dateFormat(date) }}</div>
    <div class="col-xs-3">
      <button mat-button (click)="loadNextDay()">
        <mat-icon>navigate_next</mat-icon>
      </button>
    </div>
  </div>
  <ng-container *ngFor="let item of schedulesDay">
    <page-schedule-item [schedule]="item"></page-schedule-item>
  </ng-container>
</mat-card>
